import store from '../redux/store';
import * as Selectors from '../redux/selectors';
import * as UIAction from '../redux/actions/ui.actions';
import * as NetworkActions from '../redux/actions/network.actions';

import { Alert } from '../components/popupAlerts';

export const postLink = async (tenantId = undefined, entityType = 'source', flowId = undefined) => {
  const fetchEntityPromise = entityType === 'source'
    ? store.dispatch(NetworkActions.fetchLinkedSources(undefined, flowId))
    : entityType === 'connector'
      ? store.dispatch(NetworkActions.fetchLinkedConnectors(undefined, flowId))
      : entityType === 'target'
        ? store.dispatch(NetworkActions.fetchLinkedTargets(flowId))
        : Promise.resolve(undefined);

  await Promise.all([
    store.dispatch(NetworkActions.fetchLinkedFlows(tenantId)),
    store.dispatch(NetworkActions.fetchSupportedFlows()),
    fetchEntityPromise,
  ]);
};

export const createWindowPopup = (url, title, w, h, onClose, lookupKey) => {
  UIAction.startSourceLink();
  const listener = Selectors.getListener()
  if (listener && listener.onPopupOpen) {
    listener.onPopupOpen(Selectors.getSelectedEntity()[lookupKey], Selectors.getSelectedFlow());
  }
  const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const top = height / 2 - h / 2 + dualScreenTop;
  const left = width / 2 - w / 2 + dualScreenLeft;

  const newWindow = window.open(
    url,
    title,
    'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
  );
  if (!newWindow) {
    Alert({ type: 'error', text: `Unable to start. Are pop-ups disabled?` });
  }

  // handle cross origin popup close
  let pollCount = 0
  const timer = setInterval(() => {
    // only call close callback if the popup was closed by the user in the cross origin window
    // sometimes the newWindow redirect causing the popup to force be close and we lost ref of the popup in javascript
    // due to browser security policies
    pollCount++
    if (!newWindow || newWindow.closed ) {
      // if the popup is closed too soon we will disregard the popup close event
      // causing some listeners to not be called
      if(pollCount < 5) {
        //
        clearInterval(timer);
        return
      }
      onClose();
      clearInterval(timer);
    }
  }, 500)

  // Handle cross-origin communication
  function messageHandler(event) {
    try {
      if (event.data === 'popup-closed') {
          console.log('::popup-closed')
          try{
            newWindow.close()
          } catch (error) {
            // Silently handle errors
          }
          onClose();
          window.removeEventListener('message', messageHandler);
        }
    } catch (error) {
      // Silently handle errors
    }
  }

  // Listen for messages from the opened tab
  window.addEventListener('message', messageHandler);

};
